import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Spinner } from "react-bootstrap";
import { getTopupPacks } from "../../../api/context/billing";
import { buyTopupPack } from "../checkout";
import { SelectionContext } from "../../../Context/Store";
import TopupCard from "./TopupCard";

const TopupModal = ({ isOpen, toggle }) => {
  const { refreshBillingBalance } = useContext(SelectionContext);
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingCode, setProcessingCode] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    getTopupPacks()
      .then((res) => {
        if (res?.data?.success) setPacks(res.data.data || []);
      })
      .finally(() => setLoading(false));
  }, [isOpen]);

  const handleBuy = async (pack) => {
    setProcessingCode(pack.code);
    await buyTopupPack(pack.code, {
      onSuccess: () => {
        refreshBillingBalance();
        toggle();
      },
      onDismiss: () => setProcessingCode(null),
    });
    setProcessingCode(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="billing-modal billing-modal-topup"
      size="lg"
      centered
      scrollable
    >
      <ModalHeader toggle={toggle}>Buy credits</ModalHeader>
      <ModalBody>
        <p className="text-muted mb-4" style={{ fontSize: 13 }}>
          Top-up credits never expire and activate after your monthly quota
          is used.
        </p>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : (
          <div className="billing-topup-grid">
            {[...packs]
              .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
              .map((pack) => (
                <TopupCard
                  key={pack.code}
                  pack={pack}
                  isProcessing={processingCode === pack.code}
                  onBuy={handleBuy}
                />
              ))}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default TopupModal;
